const className = 'Site'

export default class Site {
  constructor (Parse) {
    this.Parse = Parse
  }

  /**
   * Get a site query
   * http://parseplatform.org/Parse-SDK-JS/api/classes/Parse.Query.html
   * @param {string} code - Site code
   */
  get (code) {
    var Class = this.Parse.Object.extend(className)
    var query = new this.Parse.Query(Class)
    query.equalTo('data.code', code)
    query.include('data').include('change').include('rates').include('messages')
    return query
  }

  /**
   * Get a site query
   * @param brand Brand parse object
   */
  getByBrand(brand) {
    var Class = this.Parse.Object.extend(className)
    var query = new this.Parse.Query(Class)
    query.limit(1000)
    query.equalTo('brand', brand)
    query.include('data').include('change').include('rates').include('messages')
    return query
  }

  /**
   * Create a site
   * http://parseplatform.org/Parse-SDK-JS/api/classes/Parse.Object.html#methods_save
   * @param {string} code - Site code
   * @param {string} name - Site name
   * @param {Object} brand - brand must be a valid parseObject
   */
  set (code, name, brand, options = {}) {
    var Class = this.Parse.Object.extend(className)
    var object = new Class()
    var data = {code: code, name: name, brand: brand}
    object.set('data', data, {error: this.onError})
    object.set('change', null)
    object.set('rates', null)
    object.set('messages', null)

    if (brand) {
      object.set('brand', brand, {error: this.onError})
    }
    return object.save(null, options)
  }

  onError (object, error) {
    console.log('Error', error)
  }
}



//////////////////
// WEBPACK FOOTER
// ./parse-model/Site.mjs
// module id = doLK
// module chunks = 0